import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

export const selectDraftComment = (taskId?: number) =>
  createSelector(
    (state: RootState) => state.tasksBoard.draftComments,
    (draftComments) =>
      (taskId && draftComments.comments[taskId]) || {
        body: '',
        request: 'NONE',
      }
  );
